import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Link from '@bitcoin-portal/bitcoincom-pkg-components/dist/Link';
import PropTypes from 'prop-types';
import {
  StyledSection,
  SectionHeader,
  StyledParagraph,
  StyledH6,
  MainTitle,
  StyledContentBlock,
} from './styled';

const WhatHow = props => {
  const { messages, formatMessage } = useIntl();
  const { template } = props;
  const whatItems = messages[`${template}.what-how.what-read-more`];
  const howItems = messages[`${template}.what-how.how-read-more`];
  const whatParagraphs = messages[`${template}.what-how.what-paragraphs`];
  const howParagraphs = messages[`${template}.what-how.how-paragraphs`];

  const createLinkValues = paragraph => {
    const { link: singleLink, url, links } = paragraph;

    const link = singleLink ? (
      <Link href={url} newTab>
        {singleLink}
      </Link>
    ) : null;

    const namedLinks = links
      ? Object.keys(links).reduce(
          (p, c) => ({
            ...p,
            [c]: (
              <Link href={links[c].url} newTab>
                {links[c].text}
              </Link>
            ),
          }),
          {},
        )
      : null;

    return { link, ...namedLinks };
  };

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainTitle>FAQ</MainTitle>
        <SectionHeader>
          <div>
            <StyledH6>{messages[`${template}.what-how.what-title`]}</StyledH6>
            {whatParagraphs.map(item => {
              const linkValues = createLinkValues(item);

              return (
                <StyledParagraph key={item.text}>
                  <FormattedMessage
                    id={item.text}
                    defaultMessage={item.text}
                    values={linkValues}
                  />
                </StyledParagraph>
              );
            })}
            {whatItems &&
              whatItems.map(item => {
                return (
                  <StyledParagraph key={item.text}>
                    <FormattedMessage
                      id={formatMessage({
                        id: `${template}.what-how.read-more`,
                      })}
                      tagName="span"
                    />
                    <Link href={item.url}>{item.text}</Link>
                  </StyledParagraph>
                );
              })}
          </div>
        </SectionHeader>

        <SectionHeader>
          <div>
            <StyledH6>{messages[`${template}.what-how.how-title`]}</StyledH6>
            {howParagraphs.map(item => {
              const linkValues = createLinkValues(item);

              return (
                <StyledParagraph key={item.text}>
                  <FormattedMessage
                    id={item.text}
                    defaultMessage={item.text}
                    values={linkValues}
                  />
                </StyledParagraph>
              );
            })}
            {howItems &&
              howItems.map(item => {
                return (
                  <StyledParagraph key={item.text}>
                    <FormattedMessage
                      id={formatMessage({
                        id: `${template}.what-how.read-more`,
                      })}
                      tagName="span"
                    />
                    <Link href={item.url}>{item.text}</Link>
                  </StyledParagraph>
                );
              })}
          </div>
        </SectionHeader>
      </StyledContentBlock>
    </StyledSection>
  );
};

WhatHow.propTypes = {
  template: PropTypes.string.isRequired,
};

export default WhatHow;
